export const statuses = {
  pending: 'Pendente de análise',
  finished: 'Autorizado',
};

export function getName(value) {
  return statuses[value];
}
